import cx from 'classnames'
import React, { useRef, useState } from 'react'
import { MdExpandMore } from 'react-icons/md'

import { useClickOutside } from '../../../../../hooks'
import { prepareName } from '../../../utils'
import styles from '../select.module.scss'

import { SelectItem } from './select-item'

export function Single ({
  relation,
  handler,
  disabled,
  issues,
  itemId,
  lists
}) {
  const [ isOpen, setOpen ] = useState(false)
  const wrapperRef = useRef(null)
  useClickOutside(wrapperRef, () => {
    setOpen(false)
  })

  return (
    <div
      className={styles.itemsWrapper}
      ref={wrapperRef}
    >
      <div
        className={styles.typeSelect}
        onClick={() => setOpen(s => !s)}
        aria-hidden='true'
      >
        <span className={styles.label}>{prepareName(relation.key)}</span>
        <div style={{ width: '16px', height: '16px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <MdExpandMore height={16} />
        </div>
      </div>
      {lists[relation.key]?.length > 0 && (
        <div
          className={cx(styles.items, {
            [styles.hide]: !isOpen
          })}
        >
          {lists[relation.key].map(element => (
            <SelectItem
              key={element.id}
              item={element}
              disabled={disabled}
              issues={issues}
              rel={relation.values}
              handleChecked={() => {
                if (!disabled) {
                  handler({
                    id: element.id,
                    key: relation.key,
                    parentId: itemId,
                    relId: relation.id,
                    type: 'select'
                  })
                }
              }}
            />
          ))}
        </div>
      )}
    </div>
  )
}
